import {useContext} from 'react';
import {RoboAdvisorContext} from 'store/RoboAdvisor';

function useRoboAdvisor() {
    return useContext(RoboAdvisorContext);
}

export default useRoboAdvisor;